import { Icon } from '@ant-design/compatible'
import { AvailabilityStatus } from '~/gql/generated/graphql'
import { AVAILABILITY_ICONS_MAP, colorByAvailability } from '~/utils'

const AvailabilityIcon = ({
  status,
}: {
  status?: AvailabilityStatus | null
}) => (
  <Icon
    type={AVAILABILITY_ICONS_MAP[status as AvailabilityStatus]}
    style={{
      fontSize: 22,
      color: colorByAvailability(status as AvailabilityStatus),
    }}
  />
)

export default AvailabilityIcon
